import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from '@/axios'
import config from '@/constant/config'
import { toResponse } from '@/utils/common'

const { api } = config

const request = async (callback, rejectWithValue) => {
  try {
    const response = await callback()
    return response.data
  } catch (error) {
    return rejectWithValue(toResponse(error.response))
  }
}

export const getChatFaqs = createAsyncThunk(
  'chatFaq/getChatFaqs',
  async (_, { rejectWithValue }) => request(() => axios.get(api.chatFaq), rejectWithValue)
)

export const saveChatFaq = createAsyncThunk(
  'chatFaq/saveChatFaq',
  async (body, { rejectWithValue }) => request(() => axios.post(api.chatFaq, body), rejectWithValue)
)

export const updateChatFaq = createAsyncThunk(
  'chatFaq/updateChatFaq',
  async ({ id, body }, { rejectWithValue }) => request(() => axios.put(api.chatFaqDetail(id), body), rejectWithValue)
)

export const deleteChatFaq = createAsyncThunk(
  'chatFaq/deleteChatFaq',
  async (id, { rejectWithValue }) => request(() => axios.delete(api.chatFaqDetail(id)), rejectWithValue)
)

export const publishChatFaq = createAsyncThunk(
  'chatFaq/publishChatFaq',
  async (id, { rejectWithValue }) => request(() => axios.post(api.publishChatFaq(id)), rejectWithValue)
)

export const unpublishChatFaq = createAsyncThunk(
  'chatFaq/unpublishChatFaq',
  async (id, { rejectWithValue }) => request(() => axios.post(api.unpublishChatFaq(id)), rejectWithValue)
)

export const setChatFaqSuggestion = createAsyncThunk(
  'chatFaq/setChatFaqSuggestion',
  async ({ id, recommendedForChat }, { rejectWithValue }) => request(
    () => axios.post(api.suggestChatFaq(id), { recommendedForChat }),
    rejectWithValue
  )
)

export const testChatFaq = createAsyncThunk(
  'chatFaq/testChatFaq',
  async (body, { rejectWithValue }) => request(() => axios.post(api.testChatFaq,
    typeof body === 'string' ? { question: body } : body), rejectWithValue)
)

export const chatFaqSlice = createSlice({
  name: 'chatFaq',
  initialState: {},
  reducers: {}
})

export default chatFaqSlice.reducer
